'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SmartImage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _SmartImage = require('./SmartImage.styled');

var S = _interopRequireWildcard(_SmartImage);

var _toolkit = require('./../../utils/toolkit');

var _SmartImage2 = require('./formats/SmartImage.customText');

var _SmartImage3 = require('./formats/SmartImage.percentage');

var _index = require('../ScalableBox/index');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SmartImage = exports.SmartImage = function (_React$PureComponent) {
    _inherits(SmartImage, _React$PureComponent);

    function SmartImage() {
        _classCallCheck(this, SmartImage);

        return _possibleConstructorReturn(this, (SmartImage.__proto__ || Object.getPrototypeOf(SmartImage)).apply(this, arguments));
    }

    _createClass(SmartImage, [{
        key: 'renderSmartImageContent',
        value: function renderSmartImageContent() {
            var _props = this.props,
                format = _props.format,
                definition = _props.definition;

            var smartImageContent = void 0;
            if (format === 'percentage') {
                smartImageContent = React.createElement(_SmartImage3.SmartPercentageImage, { definition: definition });
            } else if (format === 'customText') {
                smartImageContent = React.createElement(_SmartImage2.SmartCustomTextImage, { definition: definition });
            } else {
                smartImageContent = null;
            }
            return smartImageContent;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                backgroundColor = _props2.backgroundColor,
                textColor = _props2.textColor,
                gradient = _props2.gradient;

            return React.createElement(S.Container, { backgroundColor: backgroundColor, textColor: textColor, gradient: gradient }, React.createElement(_index.ScalableBox, { originalHeight: SmartImage.originalHeight, originalWidth: SmartImage.originalWidth }, this.renderSmartImageContent()));
        }
    }]);

    return SmartImage;
}(React.PureComponent);

SmartImage.originalWidth = 150;
SmartImage.originalHeight = 100;
SmartImage.colorsSupportedGradients = {
    red: (0, _toolkit.color)('error'),
    lightBlue: (0, _toolkit.color)('primary', 700),
    darkBlue: (0, _toolkit.color)('secondary'),
    green: (0, _toolkit.color)('success', 700)
};
SmartImage.defaultProps = {
    backgroundColor: (0, _toolkit.color)('secondary'),
    textColor: '#fff',
    gradient: true
};
//# sourceMappingURL=SmartImage.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/SmartImage/SmartImage.js